define('TescoMobile_Checkout/js/action/validate-kba-answers',['jquery', 'Magento_Checkout/js/model/quote', '../model/choice-resource-url-manager', 'mage/storage', 'Magento_Checkout/js/model/full-screen-loader'], function ($, quote, urlManager, storage, fullScreenLoader) {
  'use strict';

  return function (deferred, responses) {
    deferred = deferred || $.Deferred();
    var serviceUrl = urlManager.getUrlForValidateKbaQuestions(quote);
    const payload = {
      cartId: quote.getQuoteId(),
      responses: responses
    };
    fullScreenLoader.startLoader();
    return storage.post(serviceUrl, JSON.stringify(payload)).always(function () {
      fullScreenLoader.stopLoader();
    });
  };
});

